
import React from 'react';
import NvFroala from 'froala/components/nv-froala';
import { FroalaViewMode, ToolbarOptions, UploadType } from 'froala/helpers/nv-froala-constants';
import { SanitizationLevel } from 'froala/helpers/sanitizer';
import NvTextArea from 'shared/components/inputs/nv-text-area';

/**
 * Generic component for rich text elements in Quizzes
 * @param { value, onchange, containerClass}
 * @returns A React component
 */
export const QuizRichTextElement = ({ value, onChange, containerClass, withCodeView = false, uploadType = UploadType.NONE }) => (
  <NvFroala
    className='option-content-froala'
    preset={FroalaViewMode.NORMAL}
    sanitizationLevel={SanitizationLevel.BASIC}
    toolbarButtons={[
      ToolbarOptions.COLOR,
      ToolbarOptions.BOLD,
      ToolbarOptions.ITALIC,
      ToolbarOptions.UNDERLINE,
      ToolbarOptions.FORMAT_UL,
      ToolbarOptions.FORMAT_OL,
      ToolbarOptions.PARAGRAPH_STYLE,
      ToolbarOptions.ALIGN,
      ToolbarOptions.INSERT_LINK,
    ]}
    uploadType={uploadType}
    withCodeView={withCodeView}
    minHeight={65}
    value={value}
    onChange={onChange}
    colorPickerContainer={containerClass}
  />
);

/**
 * Generic component for simple text elements in Quizzes
 * @param { value, onchange}
 * @returns A React component
 */
export const QuizSimpleTextComponent = ({ value, onChange }) => (
  <NvTextArea
    value={value}
    autoComplete='off'
    textareaClassName='text-large-body border-simple-text'
    onChange={(e) => onChange(e.currentTarget.value)}
  />
);

/**
 * Converts the index of a table into the right position depending on the columns
 * @param columns maximum columns
 * @param index the index in the list of elements in the table
 * @returns a String
 */
export const getTablePosition = (columns, index) => {
  if (columns <= 0 || index < 0) {
    return null;
  }

  // Calculate row and column position
  const row = Math.floor(index / columns) + 1;
  const col = index % columns;

  // Convert column number to letter(s) (like Excel: A, B, ..., Z, AA, AB, ...)
  function columnToLetter(colIndex) {
    let letters = '';
    let n = colIndex;
    while (n >= 0) {
      letters = String.fromCharCode((n % 26) + 65) + letters;
      n = Math.floor(n / 26) - 1;
    }
    return letters;
  }

  return columnToLetter(col) + row;
};

export default getTablePosition;
